export enum EXTERNAL_SYSTEM {
  INPOL = 'INPOL',
  MOS = 'MOS',
}
